import '../css/login-SO.css'
import axios from "axios"
import { useNavigate } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { setUserLogin, setStatus, setOwnerId } from "../slices/shopOwnerLoginSlice"
import Navbar from 'react-bootstrap/Navbar';
import Logo from '../images/logos.png'
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

function LOGINSO() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    let { userLogin, userstatus, ownerid } = useSelector((state) => state.ShopOwnerLogin)
    function alldata() {
        let formdata = new FormData()
        formdata.append("email", userLogin.email)
        formdata.append("password", userLogin.password)
        axios.post('https://agaram.academy/api/retail/index.php?request=shop_owner_login', formdata).then(function (response) {
            if (response.data.status == "success") {
                dispatch(setOwnerId(response.data))
                dispatch(setStatus(true))
                localStorage.setItem('ownertoken', response.data.token)
                navigate("/customerlist")
            } else {
                // navigate("/ShopOwnerLogin")
                alert("check your email or password")
            }
        })

    }




    return (
        <>
            <div className='login template  bg'>
                <div className='logopositions'>
                    <Navbar >
                        <Navbar.Brand href="#"><img src={Logo} alt='logo' width={90} id="logo" /></Navbar.Brand>

                    </Navbar>
                </div>

                <div className='positionchange'>
                    <Form style={{ minWidth: "350px", maxWidth: "600px" }} className='p-3'>
                        <h1 className='text-start mb-3'> Sign In </h1>
                        
                        <div>
                            <Form.Group as={Row} className="mb-3 mailbox" controlId="formPlaintextPassword">
                                <Form.Label column sm="3">
                                    Email
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control type="email" name='email' placeholder="email" className='detail' required 
                                    onKeyUp={(e) => dispatch(setUserLogin({
                                        ...userLogin,
                                        email: e.target.value
                                    }))}/>
                                    {/* {error.email && <span style={{ color: "red" }}>{error.email}</span>} */}
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3 pasbox" controlId="formPlaintextPassword">
                                <Form.Label column sm="3">
                                    Password
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control type="password" name='password' placeholder="Password" className='detail' requiredonKeyUp={(e) => dispatch(setUserLogin({
                                    ...userLogin,
                                    password: e.target.value
                                }))} />
                                    {/* {error.password && <span style={{ color: "red" }}>{error.password}</span>} */}
                                </Col>
                            </Form.Group>
                        </div>

                        <div className='d-flex justify-content-start '>
                            <button className='btn btn-success px-4 my-3' type='button' onClick={() => alldata()}>Sign In</button>

                        </div>
                    </Form>
                </div>
            </div>
        </>
    )
}

export default LOGINSO